// This icon file is generated automatically.
var PErrorOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6.25 10.25a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM6.5 5.5v2.88c0 .06.06.12.13.12h.75c.06 0 .12-.06.12-.13V5.5a.13.13 0 00-.13-.13h-.75a.13.13 0 00-.12.13zm7.43 6.88L7.43 1.12A.5.5 0 007 .88a.5.5 0 00-.43.26L.07 12.38a.5.5 0 00.43.74h13a.5.5 0 00.43-.74zM1.7 11.94L7 2.74l5.3 9.2H1.7z", "fill-rule": "nonzero" } }] }, "name": "p-error", "theme": "outlined" };
export default PErrorOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PErrorOutlined.js
// module id = 3363
// module chunks = 0